import type { AllRouteEndpoints } from "../routeTypes";
export const adminRequestImpersonationCacheKeys: AllRouteEndpoints[] = [];
